export const URL_SYSTEM_IDENTIFIER = "fortnox";

// WHY: mirrors FusionHub's OptionalScopeSchema — it rejects anything else.
export const OPTIONAL_SCOPES = ["salary", "assets", "timereporting"] as const;

export type OptionalScope = (typeof OPTIONAL_SCOPES)[number];
